import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { cloneDeep } from 'lodash';
var initForm = {
  fromDate: '',
  toDate: ''
};
export default {
  meta: {
    title: '评价分析',
    auth: true,
    authorityValue: "store-statistics-management"
  },
  name: 'evaluate',
  data: function data() {
    return {
      form: cloneDeep(initForm),
      newsList: [{
        tit: '评价数',
        key: 'evaluates'
      }, {
        tit: '有图评价数',
        key: 'hasFiles'
      }, {
        tit: '卖家回复数',
        key: 'replies'
      }, {
        tit: '',
        key: '',
        hide: true
      }, {
        tit: '好评数',
        key: 'positives'
      }, {
        tit: '中评数',
        key: 'neutrals'
      }, {
        tit: '差评数',
        key: 'negatives'
      }, {
        tit: '差评率',
        key: 'negativeRate'
      }]
    };
  },
  methods: {
    rangeDateChange: function rangeDateChange(e) {
      if (e === null) {
        this.form.fromDate = '';
        this.form.toDate = '';
      } else {
        this.form.fromDate = e[0];
        this.form.toDate = e[1];
      }

      this.dataBind(this.form);
    },
    dataBind: function dataBind(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.dataEvaluate(item);

              case 2:
                data = _context.sent;

                _this.newsList.forEach(function (v) {
                  return _this.$set(v, 'count', data[v.key] || 0);
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  mounted: function mounted() {
    this.dataBind();
  }
};